"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getThemeByType = void 0;
var theme_1 = require("../../../theme");
exports.getThemeByType = function (type) {
    if (type === 'tpv') {
        return theme_1.tpvTheme;
    }
    return theme_1.theme;
};
